import { getMessages } from '../../../../../../../store/constants';

export const BOARD_BUTTON_OPEN_IN_DRIVE = getMessages().getText('board_details__link_open_in_drive');
export const BOARD_BUTTON_OPEN_IN_DRIVE_MS = getMessages().getText('board_details__link_open_in_drive.ms');
export const BOARD_BUTTON_OPEN_IN_DRIVE_MS_PERSONAL = getMessages().getText('board_details__link_open_in_drive.personal.ms');
